import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async tipsters(tipster) {
    const response = await api.post(API_URL + "tipsters", tipster);
    if (response.data) return response.data;
  },

  async listaTipsters() {
    const response = await api.post(API_URL + "listaTipsters", null, { _silent403: true });
    if (response.data) return response.data;
  },

  async misTipsters() {
    const response = await api.post(API_URL + "publicista/mis-tipsters", null, { _silent403: true });
    if (response.data) return response.data;
  },

  async tablaTipsters() {
    const response = await api.post(API_URL + "listaTipsters", null, { _silent403: true });
    if (response.data) return response.data;
  },

  async guardaTipster(tipster) {
    const response = await api.post(API_URL + "guardaTipster", tipster);
    if (response.data) return response.data;
  },

  async borraTipster(userId) {
    const response = await api.post(API_URL + "borraTipster", userId);
    if (response.data) return response.data;
  },

  async validarMovilTipster(tipster) {
    const response = await api.post(API_URL + "validarMovilTipster", tipster);
    if (response.data) return response.data;
  },

  async codigoMovilTipster(tipster) {
    const response = await api.post(API_URL + "codigoMovilTipster", tipster);
    if (response.data) return response.data;
  },

  async validaCodigoTipster(tipster) {
    const response = await api.post(API_URL + "validaCodigoTipster", tipster);
    if (response.data) return response.data;
  },

  async detalleTipster(data) {
    const response = await api.post(API_URL + "detalleTipster", data);
    if (response.data) return response.data;
  },

  async exportarTipsters() {
    return await api.post(API_URL + "tipsters/export", {}, { responseType: "blob" });
  },
};
